import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Mi mamá no escribe bien, igual puede usarlo?',
  answer: '¡Sí! El libro está diseñado para que cualquier persona pueda completarlo. Las preguntas son simples, cálidas y guían paso a paso. No importa si escribe poco o mucho, lo importante es que quede su historia con sus palabras.'
}, {
  question: '¿Qué pasa si no lo completa todo?',
  answer: 'No hay presión. Cada página es independiente. Puede completarlo de a poco, a su ritmo, en el orden que quiera. Incluso una sola página ya es un recuerdo invaluable.'
}, {
  question: '¿Cuándo y cómo lo recibo?',
  answer: 'Apenas confirmás el pago recibís un email con acceso inmediato a todos los archivos PDF. En menos de 5 minutos ya podés descargarlo o reenviárselo a mamá como regalo.'
}, {
  question: '¿Funciona si mamá no vive conmigo?',
  answer: 'Perfectamente. Podés reenviarle el email directamente a ella, o imprimirlo y enviárselo por correo. Es un regalo que funciona sin importar la distancia.'
}, {
  question: '¿Por qué tiene este precio si vale tanto?',
  answer: 'Porque queremos que toda familia pueda acceder a esto. El formato digital nos permite ofrecerlo a este precio sin perder calidad. Es nuestra forma de ayudar a que ninguna historia se pierda.'
}, {
  question: '¿Qué pasa si no me gusta?',
  answer: 'Tenés 14 días de garantía total. Si por cualquier motivo no quedás satisfecho, te devolvemos el 100% de tu dinero. Sin preguntas, sin vueltas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 px-4 md:px-8 bg-orange-50" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-97">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1A1A1A] mb-12" data-id="element-98">
            ❓ Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-99">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-100">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors" data-id="element-101">
                  <span className="font-semibold text-[#1A1A1A] pr-4" data-id="element-102">
                    ❓ {faq.question}
                  </span>
                  <span className="text-[#F5A623] text-2xl flex-shrink-0" data-id="element-103">
                    {openIndex === index ? '−' : '+'}
                  </span>
                </button>

                <AnimatePresence data-id="element-104">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-105">
                      <div className="px-6 pb-4 text-gray-700 leading-relaxed" data-id="element-106">
                        ✅ {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}